import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RsvpComponent } from './rsvp/rsvp.component';

const routes: Routes = [
  {path: '', component: RsvpComponent},
  {path: 'rsvpa', component: RsvpComponent},
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
